import { createElement as rc } from 'react';
import { fromTheme, webOnlyStyles, styled, h3 } from 'lib_ui-primitives';
let _Title = styled(h3).attrs({ name: 'title' })`
    max-height: ${({ theme: { mobile, smallMobile }, collapsed }) =>
        smallMobile || (mobile && collapsed) ? '0' : '100px'};
    margin: 0;
    padding: ${({ theme: { mobile, smallMobile, viewPaddingMore }, collapsed, noPadding }) =>
        noPadding ? '0' : (smallMobile || (mobile && collapsed) ? '0' : viewPaddingMore + 'px')};
    color: ${fromTheme('defaultFontColor')};
    overflow: hidden;
    flex-shrink: 0;
    border-bottom-width: ${({ theme, noPadding }) => (theme.mobile && !noPadding ? '1px' : '0')};
    border-bottom-color: ${fromTheme('borderColor')};
`;
_Title = webOnlyStyles(_Title)`
    transition: max-height 0.3s linear;
    border-bottom-style: solid;
`;

export default function Title(props) {
    return rc(_Title, props);
}
